<template>
  <div class="content-page">
    <div v-if="isLoading">
      <OtherLoading variant="dark" />
    </div>
    <div v-else class="content-reward">
      <RewardDetailPanel :detail="privilegeDetail" :branch="branchList" />
    </div>
  </div>
</template>

<script>
import OtherLoading from "@/components/other/OtherLoading";
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import RewardDetailPanel from "@/components/reward/detail/RewardDetailPanel";
export default {
  components: {
    Breadcrumb,
    RewardDetailPanel,
    OtherLoading
  },
  data() {
    return {
      breadcrumbList: [
        {
          text: "รายละเอียดของรางวัล",
          to: "/reward"
        }
      ],
      privilegeDetail: {},
      id: this.$route.params.rewardId,
      isLoading: true,
      branchList: []
    };
  },
  async created() {
    await this.getRedeemInfo();
  },
  methods: {
    async getRedeemInfo() {
      await this.$axios
        .get(
          `${process.env.VUE_APP_API}/api/v1/Privilege/coupon_detail/${this.id}`
        )

        .then(
          async data => {
            this.isLoading = false;
            if (data.result == 1) {
              this.privilegeDetail = data.detail;
            }
          },
          error => {
            const code = parseInt(error.response && error.response.status);
            if (code === 401) {
              console.log(error);
            }
          }
        );
    }
  }
};
</script>

<style lang="scss" scoped></style>
